module.exports = __webpack_public_path__ + "static/media/logo.531b68fa.png";